import { render, staticRenderFns } from "./CellRendererActionsExam.vue?vue&type=template&id=0f5bb7ce"
import script from "./CellRendererActionsExam.vue?vue&type=script&lang=js"
export * from "./CellRendererActionsExam.vue?vue&type=script&lang=js"
import style0 from "./CellRendererActionsExam.vue?vue&type=style&index=0&id=0f5bb7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports